/* sb-slider.js — DE generieke slider (single source). Werkt op elk [data-sb-slider]-blok:
   - .sb-slider__track            = horizontale scroll-snap track (swipen/scrollen werkt al zonder JS)
   - [data-sb-slider-prev/next]   = pijlknoppen links/rechts (enhancement; standaard `hidden`)
   - [data-sb-slider-progress]    = voortgangsbalk-track, met [data-sb-slider-thumb] als duimpje
   JS toont pijlen + balk alleen bij overflow, lijnt de pijlen verticaal op de productfoto uit,
   en laat het duimpje meelopen met de scrollpositie. Zonder JS: gewoon swipen. */
(function () {
  function trackStep(track) {
    var slide = track.querySelector('.sb-slider__slide');
    if (!slide) return track.clientWidth * 0.9;
    var styles = getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function init(root) {
    if (root.sbSliderInit) return;
    var track = root.querySelector('.sb-slider__track');
    if (!track) return;
    root.sbSliderInit = true;

    var prev = root.querySelector('[data-sb-slider-prev]');
    var next = root.querySelector('[data-sb-slider-next]');
    var progress = root.querySelector('[data-sb-slider-progress]');
    var thumb = root.querySelector('[data-sb-slider-thumb]');

    var sbScrollBehavior = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -trackStep(track), behavior: sbScrollBehavior });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: trackStep(track), behavior: sbScrollBehavior });
    });

    // Pijlen verticaal centreren op de productfoto (i.p.v. midden van de hele kaart).
    function alignArrows() {
      var media = track.querySelector('.sb-card__media');
      if (!media) return;
      var sRect = root.getBoundingClientRect();
      var mRect = media.getBoundingClientRect();
      root.style.setProperty('--sb-arrow-top', (mRect.top - sRect.top + mRect.height / 2) + 'px');
    }

    function refresh() {
      var overflows = track.scrollWidth > track.clientWidth + 2;
      if (prev) prev.hidden = !overflows;
      if (next) next.hidden = !overflows;
      if (progress) progress.hidden = !overflows;

      var maxScroll = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = !overflows || track.scrollLeft >= maxScroll - 2;

      if (thumb && overflows) {
        var ratio = track.clientWidth / track.scrollWidth;     // zichtbaar deel
        var w = Math.max(ratio, 0.12);                         // min. breedte zodat 't zichtbaar blijft
        var p = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
        thumb.style.width = (w * 100) + '%';
        thumb.style.left = (p * (1 - w) * 100) + '%';
      }
      alignArrows();
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; refresh(); }); }
    }, { passive: true });
    window.addEventListener('resize', refresh, { passive: true });

    // Beelden kunnen na laden de breedte/hoogte veranderen → opnieuw meten.
    if (document.readyState !== 'complete') window.addEventListener('load', refresh, { once: true });
    refresh();
  }

  function boot() {
    var sliders = document.querySelectorAll('[data-sb-slider]');
    for (var i = 0; i < sliders.length; i++) init(sliders[i]);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
